module.exports = __webpack_public_path__ + "static/media/permissaoLocalMobile.d22c4d07.jpg";